import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";

export type GlobalSearchResults = {
  members: { id: number; name: string; org: string; image_url: string | null }[];
  organizations: { id: number; name: string; location: string }[];
  threads: { id: number; title: string; via: "thread" | "reply" }[];
  resources: { id: number; title: string; category: string; locked: boolean }[];
  docs: { id: number; slug: string; title: string; section: string }[];
};

export function useGlobalSearch(query: string) {
  return useQuery<GlobalSearchResults>({
    queryKey: ["afell", "search", query],
    queryFn: () => apiRequest(`/afell/search/?q=${encodeURIComponent(query)}`),
    enabled: query.trim().length >= 2,
    placeholderData: keepPreviousData,
  });
}
